module.exports = __webpack_public_path__ + "static/media/ArrowDownIcon.6b59d33a.svg";